import React, { useState, useRef } from 'react'
import axios from 'axios';
// const URL1 = 'https://ai-sw-backapi.ismbonline.org/api/dashboard/convert_image'
const Photo = ({ add, id, remove }) => {

  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [nameImage, setNameImage] = useState(null)
  const imgcomplet = async (file1) => {
    const formData1 = new FormData();
    formData1.append('img_burns', file1); // שם השדה שציינת

    try {
      const response = await axios.post(
        '/dashboard/convert_image',
        formData1,
        {
          responseType: 'blob', // מקבל תמונה מהשרת
        }
      );

      const imageBlob = new Blob([response.data], { type: 'image/jpeg' });
      const imageUrl = URL.createObjectURL(imageBlob);
      setNameImage(imageUrl); // מציג את התמונה
      add(id,imageBlob); // מודיע שהושלמה העלאה
    } catch (error) {
      console.error('שגיאה בשליחת התמונה:', error);
      alert('אירעה שגיאה בשליחת התמונה לשרת.');
    }
  };



  const handleFileInputChange = async (e) => {
    setLoading(true)
    const file1 = e.target?.files[0];
    console.log(file1)
    await imgcomplet(file1)
    setLoading(false)
  };

  const handleTakePhotoClick = () => {
    // Trigger the file input element to open the camera
    fileInputRef.current.click();
  };

  return (
    <div className='w-full '>
      <input
        type="file"
        accept="image/*"
        capture="environment" // This is used to specify that the camera should be used (not necessary on iOS)
        style={{ display: 'none' }} // Hide the file input element
        ref={fileInputRef}
        onChange={handleFileInputChange}
      />
      {nameImage ?
        // <div className='relative w-full  h-full'> <img className='w-full  h-[140px] rounded-lg object-contain bg-Black' src={nameImage} alt="Converted"/>
        <div className='relative w-full  h-full'> <img className='w-full  h-[140px] rounded-lg object-cover bg-Black' src={nameImage} alt="Converted" />
          <button className='absolute rounded-full px-3 py-1 -top-[15px] text-Black -right-3 z-10 bg-white  drop-shadow-[1px_1px_10px_rgba(0,0,0,0.15)] ' onClick={() => {
            remove(id)
            setNameImage(null)
            fileInputRef.current.value = '';  // זה מבטל את הבחירה בקובץ
          }} > X</button>
        </div> :
        <button className='w-full h-[140px] bg-Grey50 text-Grey500 border-2 border-Grey500 border-dashed flex justify-center items-center' disabled={loading}
          onClick={handleTakePhotoClick}
          style={{

            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
          }}
        >
          {loading ? <div class="border-gray-300 h-12 w-12 animate-spin rounded-full border-8 border-t-PraimeryBlue" /> : "+"}

        </button>}

    </div>
  );
};


export default Photo